import { Box, Text, Flex, Heading, Link, IconButton } from "gestalt";
import { useState } from "react";

export const InvitationPage = ({ jobInterviewLink }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(jobInterviewLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      setCopied(false);
    }
  };

  return (
    <Box display="flex" direction="column" width="100%" padding={3}>
      <Flex
        direction="row"
        justifyContent="start"
        alignItems="center"
        gap={50}
        padding={50}
      >
        <img
          src="/icons/logo.png"
          width="30"
          height="30"
          alt="STK Logo"
          title="STK"
        />
        <div style={{ marginRight: "10px" }}></div>
        <Heading>Interview Invitation</Heading>
      </Flex>

      <Box
        marginStart={4}
        marginEnd={4}
        padding={5}
        rounding={2}
        color="lightGray"
      >
        <Text align="center" size="lg">
          Here is the link to your customized interview. Please send it to the
          candidates.
        </Text>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          padding={2}
          rounding={2}
          color="white"
          borderStyle="sm"
          marginTop={4}
        >
          <Text color="darkGray" overflow="normal" size="lg">
            {jobInterviewLink}
          </Text>
          <IconButton
            accessibilityLabel="Copy link"
            icon="copy-to-clipboard"
            iconColor="darkGray"
            size="sm"
            onClick={handleCopy}
          />
          {copied && (
            <Text color="success" size="sm" marginStart={2}>
              Copied!
            </Text>
          )}
        </Box>
      </Box>
    </Box>
  );
};
